'use strict';

var $ = require('jquery');
require('gsap');
require('gsap/ScrollToPlugin');
var ScrollMagic = require('scrollmagic');
require('scrollmagic/scrollmagic/minified/plugins/animation.gsap.min');

var controller = new ScrollMagic.Controller();

var loadingAnimation = new TimelineMax();
loadingAnimation
  .fromTo('.loading__icon', .7, {
    scale: 1,
    opacity: 0,
    ease: Power2.easeIn
  }, {
    opacity: 1
  })
  .fromTo('.loading__icon', 2, {
    ease: Power3.easeOut
  }, {
    scale: 1.15,
    opacity: 0
  }, '+=.2')
  .fromTo('.loading__top', .9, {
    scaleY: 1,
    z: 0,
    ease: Power2.easeOut
  }, {
    scaleY: 0
  }, '-=1.4')
  .fromTo('.loading__bottom', 1, {
    scaleY: 1,
    ease: Power3.easeOut
  }, {
    scaleY: 0
  }, '-=1.2')
  .to('.wrapper', .7, {
    opacity: 1
  })
  .to('.loading', .1, {
    display: 'none'
  });

var toTop = $('.to-top');
toTop.on('click', function() {
  var $this = $(this),
    href = $this.attr('href'),
    topY = $(href).offset().top;

  TweenMax.to($(window), 1, {
    scrollTo: {
      y: topY,
      autoKill: true
    },
    ease: Power2.easeInOut
  });

  return false;
});

var headerBackground = new TweenMax
  .to('#headerBg', .8, {
    scaleY: 1,
    force3D: true,
    ease: Power3.easeInOut
  });

var sceneHeader = new ScrollMagic.Scene({
  triggerElement: '#concept',
  triggerHook: 'onLeave',
  duration: 0,
  offset: -100
})
  .setTween(headerBackground)
  .addTo(controller);

var catchAnimation = new TimelineMax();
catchAnimation
  .staggerFromTo('.catch-group path', .8, {
    opacity: 0
  }, {
    opacity: 1
  }, .15)
  .staggerFromTo('.catch-group-second path', 1, {
    opacity: 0
  }, {
    opacity: 1
  }, .4, '-=.3')
  .fromTo('.concept__text', .5, {
    opacity: 0
  }, {
    opacity: 1
  }, '-=.5');

var sceneCatch = new ScrollMagic.Scene({
  triggerElement: '#concept',
  triggerHook: 'onLeave',
  duration: 0,
  offset: -300
})
  .reverse(false)
  .setTween(catchAnimation)
  .addTo(controller);

var accessLogoAnimation = new TweenMax
  .fromTo('.contact__image .logo-name-partial', 1, {
    opacity: 0,
    ease: Power3.easeIn
  }, {
    opacity: 1
  });

var sceneAccess = new ScrollMagic.Scene({
  triggerElement: '#access',
  triggerHook: 'onLeave',
  duration: 200,
  offset: -300
})
  .reverse(false)
  .setTween(accessLogoAnimation)
  .addTo(controller);

var mapOverlayAnimation = new TweenMax
  .to('#overlay', .7, {
    scaleY: 0,
    ease: Power2.easeIn
  });

var sceneMapOverlay = new ScrollMagic.Scene({
  triggerElement: '#gmap',
  triggerHook: 'onEnter',
  duration: 0,
  offset: 150
})
  .reverse(false)
  .setTween(mapOverlayAnimation)
  .addTo(controller);

$('#triggerAnimationLogo')
  .on('mouseenter', function() {
    var logoEnterAnimation = new TweenMax
      .to('.logo-partial .cls-3', .7, {
        opacity: 0,
        scale: .8,
        yoyo: true,
        repeat: 1,
        ease: Power2.easeInOut
      });
  })
  .on('mouseleave', function() {
    var logoLeaveAnimation = new TweenMax
      .to('.logo-partial .cls-3', .5, {
        opacity: 1,
        scale: 1
      });
  });

$('#header .fb-icon')
  .on('mouseenter', function() {
    var fbLogoEnterAnimation = new TweenMax
      .to('#header .fb-icon path', .7, {
        fill: '#020303',
        yoyo: true,
        repeat: -1,
        ease: Power2.easeInOut
      });
  })
  .on('mouseleave', function() {
    var fbLogoLeaveAnimation = new TweenMax
      .to('#header .fb-icon path', .5, {
        fill: '#c09466'
      });
  });

$('#header .instagram-icon')
  .on('mouseenter', function() {
    var fbLogoEnterAnimation = new TweenMax
      .to('#header .instagram-icon path', .7, {
        fill: '#020303',
        yoyo: true,
        repeat: -1,
        ease: Power2.easeInOut
      });
  })
  .on('mouseleave', function() {
    var fbLogoLeaveAnimation = new TweenMax
      .to('#header .instagram-icon path', .5, {
        fill: '#c09466'
      });
  });
